// extracted by mini-css-extract-plugin
export default {"outterBoxCss":"RunForm_outterBoxCss__r6ZVQ","loaderBoxCss1":"RunForm_loaderBoxCss1__FSkL5","loaderBoxCss2":"RunForm_loaderBoxCss2__Cqhlz"};